import { render } from "./VUEComponenteGraficoIncidenza.vue?vue&type=template&id=9f6d0840"
import script from "./VUEComponenteGraficoIncidenza.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoIncidenza.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__